/*
 * @description:
 * @author: Jason Wong
 * @since: 2022-05-18 16:40:56
 */
import MailClient from "../../utils/wsClient/mailClient";
import { consoleIfDevelopment, errorIfDevelopment } from "../../configs/env";
import Store from "../../store";
import { isBlank } from "../../utils/String";

const INTERVAL = 5 * 1000;

class MessageConnector {
  constructor() {
    this._msgClient = null;
    this._initNumber = 1;
    this._eventHandlers = {};

    this._msgClientRegiterPoint = {};
  }

  start(userId) {
    if (!userId) throw new Error("Parameter userId can not be null.");
    this._userId = userId;
    this._isStarted = true;
    this._initWS();
  }

  stop() {
    consoleIfDevelopment("stop system connector.");
    this._closeWS(this._msgClient);
    this._msgClient = null;
    this._initNumber++;
    this._isStarted = false;
  }

  addEventListener(event, cb) {
    if (isBlank(event) || !cb || !(cb instanceof Function)) {
      return;
    }

    if (this._msgClientRegiterPoint[event] == null) {
      this._msgClientRegiterPoint[event] = (ev) => {
        console.log("#-# notice receivered", ev);
        this._triggerEvent(event, ev);
      };
      if (this._msgClient != null) {
        this._msgClient.on(event, this._msgClientRegiterPoint[event]);
      }
    }

    let eventGroup = this._eventHandlers[event];
    if (!eventGroup) {
      eventGroup = [];
      this._eventHandlers[event] = eventGroup;
    }
    eventGroup.push(cb);
  }

  removeEventListener(event, cb) {
    if (!event) return;

    if (!cb) {
      this._eventHandlers[event] = null;
    } else {
      const eventGroup = this._eventHandlers[event];
      if (eventGroup) {
        const pos = eventGroup.indexOf(cb);
        pos > -1 && eventGroup.splice(pos, 1);
      }
    }
  }

  _triggerEvent(event, ev) {
    if (!!event && !!this._eventHandlers[event]) {
      const eventGroup = this._eventHandlers[event];
      for (let i = 0; i < eventGroup.length; i++) {
        const eventHandler = eventGroup[i];
        try {
          eventHandler(ev);
        } catch (error) {
          errorIfDevelopment(error);
        }
      }
    }
  }

  get started() {
    return this._isStarted;
  }

  _closeWS(msgClient) {
    if (!msgClient) return;
    try {
      msgClient.close();
    } catch (err) {
      console.error("Failed to close ws client:", err);
    }
  }

  throwIfInitNumberInvalid(initNumber) {
    if (initNumber != this._initNumber) {
      throw new OperationCanceledError();
    }
  }

  async _initWS(initNumber) {
    this._closeWS(this._msgClient);
    this._msgClient = null;

    console.log(`start to int mail connector:\r\n\tuserid:${this._userId}`);
    const curInitNumber = initNumber != null ? initNumber : ++this._initNumber;
    let newClient = null;
    try {
      newClient = new MailClient({
        timeout: INTERVAL,
      });
      await newClient.connect();
      this.throwIfInitNumberInvalid(curInitNumber);
      this._msgClient = newClient;
      //register handler
      for (const event of Object.keys(this._msgClientRegiterPoint)) {
        newClient.on(event, this._msgClientRegiterPoint[event]);
      }
      this._msgClient.on("closed", (ev) => {
        setTimeout(() => {
          this._initWS();
        }, INTERVAL);
      });

      consoleIfDevelopment("init done!");
      this._triggerEvent("ready", {});
    } catch (err) {
      console.error(`init error:`, err);
      if (!!newClient) this._closeWS(newClient);
      if (!(err instanceof OperationCanceledError)) {
        setTimeout(() => {
          this._initWS(curInitNumber);
        }, INTERVAL);
      }
    }
  }
}

class OperationCanceledError extends Error {
  constructor() {
    super();
  }
}

class SystemMessageConnector {
  constructor() {
    this.messageConnector = new MessageConnector();
  }

  attachMessageConnector() {
    console.log("attach message connector");
    console.log(`user.state:${JSON.stringify(Store.state.user)}`);
    return Store.watch(
      (state, getters) => {
        console.log("#_#_#_#", state, getters, state.user.userInfo, getters.isTokenValid);
        return { user: state.user.userInfo, isTokenValid: getters.isTokenValid };
      },
      (newVal, oldVal) => {
        console.log("#-# user-state changed!", newVal, oldVal);
        if (newVal.user != null && newVal.isTokenValid) {
          this.messageConnector.start(newVal.user.id);
        } else {
          this.messageConnector.stop();
        }
      }
    );
  }

  addEventListener(event, cb) {
    this.messageConnector.addEventListener(event, cb);
  }

  removeEventListener(event, cb) {
    this.messageConnector.removeEventListener(event, cb);
  }
}

const systemMessageConnector = new SystemMessageConnector();
export { systemMessageConnector };
